// extracted by mini-css-extract-plugin
module.exports = {"contact":"header_contact__BNlZP w-[20px] h-[20px] bg-no-repeat mr-[8px]"};